<template>
    <slot></slot>
    <PageBreakpointsButton v-model="chosenRwd" />
    <div class="absolute bottom-6 left-6 flex items-center space-x-2">
        <PagePreviewButton v-if="views && views.length > 1" v-model="chosenView" :views="views" />
        <PagePreviewButton v-if="!hideLang" v-model="chosenLang" :views="langs" hide-icon />
    </div>
</template>

<script>
import { PageBreakpointsButton, PagePreviewButton } from "@easy/ui/page-components";
import { mapState, mapMutations } from "vuex";
import { previewLanguageService } from "@/shared/user/preview-language.service";

export default {
    components: {
        PageBreakpointsButton,
        PagePreviewButton,
    },
    created() {
        this.$watch(
            () => this.$route.query.view,
            (newView) => this.setupNewViewFromQuery(newView),
            { deep: true, immediate: true }
        );
    },
    props: {
        views: {
            type: Array,
            default: () => [],
        },
        modelValue: {
            type: String,
            default: "",
        },
        hideLang: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            rwd: "desktop",
            langs: previewLanguageService.availableLanguagesWithLabels,
        };
    },
    watch: {
        //app language change preview langueage
        lang: {
            immediate: true,
            handler(value) {
                this.chosenLang = value;
            },
        },
    },
    computed: {
        ...mapState(["lang", "previewLang"]),
        chosenView: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:model-value", value);
                const { path, query } = this.$route;
                this.$router.replace({ path, query: { ...query, view: value } });
            },
        },
        chosenLang: {
            get() {
                return this.previewLang;
            },
            set(value) {
                this.setPreviewLanguage(value);
            },
        },
        chosenRwd: {
            get() {
                return this.rwd;
            },
            set(value) {
                this.rwd = value;
                this.setSize(this.rwd);
            },
        },
        defaultViewValue() {
            const [first = {}] = this.views;
            return first.value;
        },
    },
    methods: {
        ...mapMutations(["setSize", "setPreviewLanguage"]),
        setupNewViewFromQuery(view) {
            const { value } = this.views.find((o) => o.value === view) || {};
            this.chosenView = value || this.defaultViewValue;
        },
    },
};
</script>
